<div class="h-full min-h-0 flex flex-col bg-white relative">
  <div #tripTitle class="relative transition-all duration-150 ig-tp-flex-item" [class.px-4]="!canEditTrip"
    [class.mt-4]="!canEditTrip">
    <div
      class="w-full flex items-center justify-between gap-3 px-4 py-2 rounded-lg border-b border-gray-200 bg-gray-50 sticky top-0 z-10 min-h-[60px]"
      [class.pl-8]="isEditMode">

      <span class="flex items-center gap-3">
        <h3 class="text-lg font-bold text-gray-800">{{ currentTrip?.title }}</h3>
        <span *ngIf="canEditTrip" class="underline cursor-pointer text-blue-500" (click)="editOrSave($event)">{{
          isEditMode ?
          "Save" : "Edit" }}</span>

        <span *ngIf="isEditMode" class="underline cursor-pointer text-sm text-gray-400"
          (click)="cancelEdit()">Cancel</span>
      </span>
      <button *ngIf="!isEditMode" (click)="closeDetailsPanel()"
        class="text-gray-400 hover:text-gray-600 bg-gray-200 transition-colors !w-6 !h-6 rounded-full flex items-center justify-center">
        <mat-icon class="!leading-6">close</mat-icon>
      </button>
    </div>

    <div class="flex items-center justify-between gap-6 w-6 absolute top-4 left-3 z-10">
      <div class="w-full">
        <div class="relative flex gap-2 items-start">

          <span *ngIf="isEditMode"
            class="bg-blue-900 rounded-full !w-6 !h-6 min-w-[24px] flex justify-center items-center"
            #editTitleMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="editTitleMenu">
            <mat-icon class="text-[12px] !w-3 !h-[15px] text-white cursor-pointer">
              border_color
            </mat-icon>
            <mat-menu #editTitleMenu="matMenu" class="ig-text-color-edit !rounded-md px-6 py-2">
              <div igClickStopPropagation (keydown)="onKeyDown($event)">
                <p class="text-lg font-semibold text-gray-600 !mb-3">
                  Edit Trip Title
                </p>

                <ig-field [control]="titleForm.get('title')" label="Title" icon="title"
                  igClickStopPropagation></ig-field>

                <ig-button class="" cls="w-[80px]" (trigger)="setTripTitle(editTitleMenuTrigger)">
                  OK
                </ig-button>
              </div>
            </mat-menu>
          </span>
        </div>

      </div>

    </div>
  </div>
  <div #tripContainer [class.select-none]="isDragging"
    class="ig-tp-trip-details-container ig-tp-flex-item overflow-y-auto flex-1 min-h-0 relative"
    [class.flex]="isSharedTripDesktopLayout" [class.gap-2]="isSharedTripDesktopLayout">
    <div *ngIf="showTripInfoPane" class="min-h-0" [class.w-[35%]]="isSharedTripDesktopLayout" [class.pl-4]="!canEditTrip"
      [class.min-w-[400px]]="isSharedTripDesktopLayout" [class.h-full]="isSharedTripDesktopLayout"
      [class.flex-1]="!isSharedTripDesktopLayout">
      <p class="text-xs px-4 py-2" *ngIf="currentTrip.days.length > 1 && canEditTrip">Points of interest in this trip may have been allocated
      to multiple days. Edit the trip details and
      move places to different dates as needed</p>

    <div *ngIf="isEditMode" class="absolute top-0 right-2 z-10">
      <button (click)="addDay()"
        class="text-gray-400 hover:text-gray-600 bg-gray-200 transition-colors !w-6 !h-6 rounded-full flex items-center justify-center">
        <mat-icon class="!leading-6">add</mat-icon>
      </button>
    </div>

    @if (!currentTrip.days.length) {
    <p class="mt-20 text-gray-400 px-10 text-[16px] leading-6 text-center flex flex-col items-center gap-4">
      <ig-image [src]="
                              'https://pic.rmb.bdstatic.com/bjh/user/d0283ed699ccb053bbce0789865cd9b5.jpeg'
                            " cls="!w-20 !h-20 rounded-full"></ig-image>
      You haven't added any days, events or places to visit
      to this trip yet.
    </p>
    }

    <mat-tab-group #daysTabGroup class="h-full relative" [selectedIndex]="selectedDayIndex"
      (selectedIndexChange)="switchDays($event)">
      @for (day of currentTrip?.days; let dayIndex = $index;
      track dayIndex) {

      <mat-tab [label]="day.dateText" class="cursor-pointer relative">
        <div class="ig-trip-day-pane" [class.pb-16]="!getAvailableAttractions(day.attractions).length">
          <div *ngIf="isEditMode" class="absolute bottom-10 w-full flex justify-center cursor-pointer gap-2 z-20"
            [class.!bottom-0]="!getAvailableAttractions(day.attractions).length">
            <span class="bg-white rounded-full px-4 flex">
              <mat-icon [class.!text-[#e9e9e9]]="dayIndex === 0" [class.!cursor-not-allowed]="dayIndex === 0"
                (click)="moveDayLeft(dayIndex)" matTooltip="Move this day to the left"
                class="!w-8 !h-8 rounded-full bg-white text-blue-900 text-[20px] leading-[30px] text-center cursor-pointer">
                swipe_left_alt
              </mat-icon>
              <mat-icon #editDayMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="editDayMenu"
                (menuOpened)="onEditDayMenuOpened(day)"
                class="!w-8 !h-8 rounded-full bg-white text-blue-900 text-[16px] leading-[30px] text-center">
                border_color
              </mat-icon>
              <mat-icon (click)="showDeleteDayConfirm(dayIndex)"
                class="!w-8 !h-8 rounded-full bg-white text-red-400 text-[20px] leading-[30px] text-center">
                delete_forever
              </mat-icon>

              <mat-icon [class.!text-[#e9e9e9]]="
                                    dayIndex === currentTrip.days.length - 1
                                  " [class.!cursor-not-allowed]="
                                    dayIndex === currentTrip.days.length - 1
                                  " (click)="moveDayRight(dayIndex)" matTooltip="Move this day to the right"
                class="!w-8 !h-8 rounded-full bg-white text-blue-900 text-[20px] leading-[30px] text-center cursor-pointer">
                swipe_right_alt
              </mat-icon>

              <div class="w-full absolute left-0 bottom-9 flex items-center justify-center">
                <ig-confirm-dialog *ngIf="deleteDayIndex === dayIndex" class="!relative !w-[300px]"
                  (confirm)="deleteDay(dayIndex)" (cancel)="closeDeleteDayConfirm()" igClickStopPropagation
                  text="Are you sure you want to remove this day? You still need to save the changes after the deletion.">
                </ig-confirm-dialog>
              </div>

              <mat-menu #editDayMenu="matMenu" class="ig-text-color-edit !rounded-md px-6 py-2">
                <div igClickStopPropagation (keydown)="onKeyDown($event)">
                  <p class="text-lg font-semibold text-gray-600 !mb-3">
                    Edit This Date
                  </p>
                  <div class="mt-4">
                    <ig-field [control]="titleForm.get('date')" label="Day title" icon="calendar_today"
                      igClickStopPropagation>
                    </ig-field>
                  </div>

                  <ig-button cls="w-[80px]" (trigger)="editDay(day, editDayMenuTrigger)">
                    ok
                  </ig-button>
                </div>
              </mat-menu>
            </span>
          </div>

          <div cdkDropList (cdkDropListDropped)="onAttractionDrop($event, day)"
            class="overflow-y-auto pb-24 ig-ai-trip-responsive-height">
            <div *ngIf="isEditMode" class="mx-[30px] my-2"
              [class.h-[50vh]]="!getAvailableAttractions(day.attractions).length">
              <ig-search-attractions *ngIf="currentTrip" [existing]="currentTrip.days[dayIndex].attractions"
                [style]="'light'" [hubName]="hubName" [searchFor]="'all'" [limit]="dayAttractionLimit"
                (addPlace)="addPlace($event, dayIndex)"></ig-search-attractions>
            </div>

            <span [class.ig-hide]="!isEditMode || day.note" #editDayNoteMenuTrigger="matMenuTrigger"
              [matMenuTriggerFor]="editDayNoteMenu" (click)="titleForm.get('note').setValue('')" class="flex items-center w-fit rounded-full bg-white mx-auto py-1 px-3 text-gray-500 gap-3 border
                border-dashed border-gray-300 cursor-pointer"
              [class.absolute]="!getAvailableAttractions(day.attractions).length"
              [class.top-[68px]]="!getAvailableAttractions(day.attractions).length"
              [class.left-[30%]]="!getAvailableAttractions(day.attractions).length">
              <mat-icon class="!w-4 !h-4 text-[16px]">note</mat-icon>
              <span class="text-xs">Add a note for this day</span>
            </span>

            <div [class.ig-hide]="!day.note" class="w-full px-8 text-sm text-gray-500 mt-2 mb-4 text-center relative">
              {{ day.note }}
              <mat-icon [class.ig-hide]="!isEditMode" (click)="
                                    titleForm.get('note').setValue(day.note)
                                  " #editDayNoteMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="editDayNoteMenu"
                class="bg-white !w-6 !h-6 text-center leading-[22px] text-[14px] rounded-full text-blue-950 cursor-pointer absolute right-6 -top-2">
                border_color
              </mat-icon>
            </div>

            <mat-menu #editDayNoteMenu="matMenu" class="ig-text-color-edit ig-tp-note-edit !rounded-md px-6 py-2">
              <div igClickStopPropagation (keydown)="onKeyDown($event)">
                <p class="text-lg font-semibold text-gray-600 !mb-3">
                  {{ day.note ? "Edit Note" : "Add a Note" }}
                </p>

                <div class="mt-4">
                  <ig-field [control]="titleForm.get('note')" label="Note" mode="textarea" icon="note"
                    igClickStopPropagation>
                  </ig-field>
                </div>

                <ig-button class="" cls="w-[80px]" (trigger)="
                                      editDayNote(day, editDayNoteMenuTrigger)
                                    ">
                  ok
                </ig-button>
              </div>
            </mat-menu>

            @for (attraction of getAvailableAttractions(day.attractions); let
            attractionIndex = $index; track attractionIndex) {

            <ig-trip-plan-list [day]="day" [attractionIndex]="attractionIndex" [isEditMode]="isEditMode"
              [isShowPlans]="true"></ig-trip-plan-list>

            <div *ngIf="isEditMode" class="flex items-center justify-center mt-3">
              <ig-create-edit-plan [attraction]="attraction"></ig-create-edit-plan>
            </div>

            <div class="rounded-2xl flex h-[90px] mt-3 relative px-8 cursor-pointer" cdkDrag
              [cdkDragDisabled]="!isEditMode" (click)="clickAttraction(attraction)" [cdkDragData]="attraction"
              (cdkDragStarted)="isDragging = true" (cdkDragEnded)="isDragging = false"
              [class.!cursor-grab]="isEditMode">
              <ig-image [src]="attraction.item.cover?.source" cls="w-full h-full rounded-l-2xl"
                class="w-[calc(23%+70px)] rounded-l-2xl"></ig-image>
              <div class="w-[77%] rounded-r-2xl bg-[#e6e6fb] py-3 px-5 relative text-xs">
                <p class="text-purple-400 font-semibold text-[13px] max-lines-2">
                  {{ attraction.item.name }}
                  <span *ngIf="attraction.item['rating']" class="gap-1 items-start inline-flex">
                    <mat-icon class="text-[gold] !w-2.5 !h-4 text-[12px]">star</mat-icon>
                    <span class="text-gray-500 font-normal text-xs">{{
                      attraction.item["rating"] }}</span>
                  </span>
                </p>

                <p *ngIf="getCategoryText(attraction.item)" class="max-lines-1">
                  {{ getCategoryText(attraction.item) }}
                </p>
                <p *ngIf="attraction.item['timeOneLine']" class="max-lines-1 relative">
                  <mat-icon *ngIf="attraction.item['isExpired']"
                    class="!w-4 !h-4 text-[14px] leading-5 mr-1 text-red-400"
                    matTooltip="This event is expired">info</mat-icon>{{
                  attraction.item["timeOneLine"] }}
                </p>
                <p class="max-lines-1">
                  {{ attraction.item.address.address || attraction.item.address }}
                </p>

                <ng-container *ngIf="isEditMode">
                  <div
                    class="flex justify-center items-center absolute top-2 right-2 rounded-full w-6 h-6 bg-white cursor-pointer"
                    [matTooltip]="getAvailableAttractions(day.attractions).length === 1 && (attraction.prePlans?.length || attraction.postPlans?.length)
                                          ? 'Delete this attraction will remove all the plans within this day.'
                                          : ''" (click)="deleteAttraction(day, attractionIndex)"
                    igClickStopPropagation>
                    <mat-icon class="!w-4 !h-4 text-[16px] text-red-400">
                      delete_forever
                    </mat-icon>
                  </div>
                  <!-- <div [class.ig-hide]="currentTrip.days.length === 1"
                    class="flex justify-center items-center absolute top-2 right-9 rounded-full w-6 h-6 bg-white cursor-pointer">
                    <mat-icon class="!w-4 !h-4 text-[16px] text-blue-900" #moveDayMenuTrigger="matMenuTrigger"
                      [matMenuTriggerFor]="moveDayMenu" igClickStopPropagation>
                      swap_horiz
                    </mat-icon>
                    <mat-menu #moveDayMenu="matMenu" class="ig-text-color-edit !rounded-md px-6 py-2">
                      <div igClickStopPropagation (keydown)="onKeyDown($event)">
                        <p class="text-lg font-semibold text-gray-600 !mb-3">
                          Move to Date
                        </p>

                        <mat-form-field appearance="outline" igClickStopPropagation>
                          <mat-label>Date</mat-label>
                          <mat-select [(ngModel)]="moveToDate">
                            <mat-option *ngFor="
                                                  let d of getAvailableDates(
                                                    day
                                                  )
                                                " [value]="d.dateText">{{ d.dateText }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                        <p *ngIf="
                                              day.attractions.length === 1 &&
                                              (day.attractions[0].prePlans
                                                ?.length ||
                                                day.attractions[0].postPlans
                                                  ?.length)
                                            " class="text-xs flex items-center gap-2 -translate-y-2.5 text-gray-600">
                          <mat-icon class="text-red-400 !w-4 !h-4 text-[14px]">warning
                          </mat-icon>
                          Moving this attraction will remove
                          all the plans within this day.
                        </p>

                        <ig-button class="" cls="w-[80px]" (trigger)="
                                              saveMoveDate(
                                                day,
                                                attractionIndex,
                                                moveDayMenuTrigger
                                              )
                                            ">
                          OK
                        </ig-button>
                      </div>
                    </mat-menu>
                  </div> -->
                </ng-container>
              </div>
              <div
                class="rounded-full w-6 h-6 flex items-center justify-center bg-[gold] text-gray-600 font-semibold absolute left-6 -top-2.5">
                {{ attractionIndex + 1 }}
              </div>
            </div>
            }
          </div>

          <ig-trip-plan-list *ngIf="getAvailableAttractions(day.attractions).last()?.postPlans?.length" [day]="day"
            [attractionIndex]="getAvailableAttractions(day.attractions).length - 1" [planType]="'postPlans'"
            [isEditMode]="isEditMode" [isShowPlans]="true"></ig-trip-plan-list>

          <!-- <div *ngIf="isEditMode && day.attractions.length" class="flex items-center justify-center mt-3">
          <ig-create-edit-plan [attraction]="day.attractions.last()" type="postPlans"></ig-create-edit-plan>
        </div> -->

          @if (!getAvailableAttractions(day.attractions).length) {
          <p
            class="mt-20 text-gray-400 px-10 text-[16px] leading-6 text-center flex flex-col items-center gap-4 absolute top-[100px]">
            <ig-image [src]="
                                  'https://pic.rmb.bdstatic.com/bjh/user/d0283ed699ccb053bbce0789865cd9b5.jpeg'
                                " cls="!w-20 !h-20 rounded-full"></ig-image>
            You haven't added any events or places to visit to
            this day yet.
          </p>
          }
        </div>

      </mat-tab>
      }
    </mat-tab-group>
    </div>
    <div *ngIf="isSharedTripDesktopLayout" class="w-[65%] h-full relative pt-2.5 pr-4 pb-2.5 pl-2">
      <ig-google-map class="h-full w-full rounded-br-3xl" [markers]="mapMarkers" [useDefaultMarkerClickStyle]="false"
        (onMarkerClick)="markerClick($event, 'event')" (onDetailsWindowClose)="onDetailsWindowClose($event)"
        (onInfoWindowClick)="infoWindowClick($event)"></ig-google-map>
    </div>
    <div *ngIf="isShowMap && !isSharedTripDesktopLayout"
      class="flex-grow h-full relative pt-2.5 pr-4 pb-2.5 pl-2 rounded-br-3xl mobile:z-10 mobile:absolute mobile:w-full mobile:h-[calc(100%-68px)]">
      <ig-google-map class="h-full w-full rounded-br-3xl" [markers]="mapMarkers" [useDefaultMarkerClickStyle]="false"
        (onMarkerClick)="markerClick($event, 'event')" (onDetailsWindowClose)="onDetailsWindowClose($event)"
        (onInfoWindowClick)="infoWindowClick($event)"></ig-google-map>

      <div class="absolute top-4 left-4 z-10">
        <button (click)="closeMap()"
          class="bg-[#1a575f] text-white px-4 py-2 rounded-full flex items-center gap-2 hover:bg-[#245865] transition-colors shadow-lg mobile:text-base">
          <span class="text-sm font-bold mobile:text-base">Close Map</span>
        </button>
      </div>
    </div>
    </div>

    <div *ngIf="!isEditMode && showTripInfoPane" igClickStopPropagation
      class="absolute z-50 bottom-16 rounded-full w-16 h-16 bg-white cursor-pointer shadow-lg text-center ig-tp-trip-func"
      [style.right]="isSharedTripDesktopLayout ? 'calc(65% + 20px)' : '20px'"
      (click)="!pdfProgress && (isShowTripFunctions = !isShowTripFunctions)">
      <div class="relative">
        <mat-icon *ngIf="!pdfProgress" class="!text-[32px] !leading-[64px] overflow-visible relative z-20">
          {{ isShowTripFunctions ? "expand_more" : "menu" }}
        </mat-icon>

        <ig-loading-dot *ngIf="pdfProgress" matTooltip="Generating PDF..."
          class="relative z-[31] scale-[0.65] block translate-y-4 translate-x-0.5">
        </ig-loading-dot>
        <mat-progress-spinner *ngIf="pdfProgress" mode="determinate" [strokeWidth]="3" [diameter]="64" [value]="pdfProgress"
          class="-translate-y-[50px]"></mat-progress-spinner>

        <mat-icon *ngIf="true" [matTooltip]="pdfProgress ? '' : 'Export to PDF'" matTooltipPosition="left"
          igClickStopPropagation
          class="opacity-0 transition-all duration-150 z-10 absolute left-2 top-0 shadow-lg" (click)="exportPDF()"
          [class.!opacity-100]="isShowTripFunctions" [class.translate-y-[-62px]]="isShowTripFunctions">picture_as_pdf
        </mat-icon>

        <mat-icon *ngIf="!isSharedTripDesktopLayout" matTooltip="Show on the map" matTooltipPosition="left"
          class="opacity-0 transition-all duration-150 z-10 absolute left-2 top-0 shadow-lg" igClickStopPropagation
          (click)="showMobileMap(selectedDayIndex)" [class.opacity-100]="isShowTripFunctions"
          [class.translate-y-[-122px]]="isShowTripFunctions">room
        </mat-icon>

        <mat-icon *ngIf="canEditTrip" matTooltip="Share this trip" matTooltipPosition="left" igClickStopPropagation
          class="opacity-0 transition-all duration-150 z-10 absolute left-2 top-0 shadow-lg" (click)="shareTrip()"
          [class.!opacity-100]="isShowTripFunctions" [class.translate-y-[-182px]]="isShowTripFunctions">share
        </mat-icon>

        <mat-icon *ngIf="!canEditTrip" matTooltip="Save this trip to my account to start editing" matTooltipPosition="left"
          class="opacity-0 transition-all duration-150 z-10 absolute left-2 top-0 shadow-lg" (click)="copyTrip()"
          [class.!opacity-100]="isShowTripFunctions" [class.translate-y-[-182px]]="isShowTripFunctions" igClickStopPropagation
          [class.!translate-y-[-122px]]="isSharedTripDesktopLayout && isShowTripFunctions">save
        </mat-icon>
      </div>
  </div>

</div>
